// src/api/user.ts
import ApiService from "@/utils/request";
export const uamApi = {
    // 利旧资产类型占比
    assetType: () => ApiService.get("/uam/datav/screen/total/0"),
    // 共享资产
    shareAssets: () => ApiService.get("/uam/datav/screen/totalAsset/0?limit=20"),
    // 利旧资产总量变化
    reuseAsset: () => ApiService.get("/uam/datav/screen/assetYearlyTrend"),
    // 服务项目统计
    totalAssetByProject: () => ApiService.get("/uam/datav/screen/totalAssetByProject/0?limit=20"),
    // 领用数量接口
    totalAssetByDept: (params) => ApiService.get("/uam/datav/screen/totalAssetByDept/0", params),
    // 按资产区域统计
    area: (params) => ApiService.get("/uam/datav/screen/area/0/1"),
    // 按资产出入库统计
    inout: () => ApiService.get("/uam/datav/screen/inout/0"),
    // 按资产出入库统计
    byStatus: () => ApiService.get("/uam/datav/screen/statStatus/0"),
    // 3D大模型资产（固定资产）
    getLocation: (params) => ApiService.get("/uam/datav/screen/getLocation", params),
};
